import { Dispatch } from "redux";
import axios from "axios";
import {
  LOADING_SHOP,
  FETCH_SHOP,
  FETCH_SHOP_TYPE,
  FETCH_SHOP_PRODUCT,
  ShopActionTypes,
  LOADING_PRODUCT_BUTTONS,
  SET_LOGIN,
  RESET_SHOP,
  FETCH_MENU,
} from "./types";
import { PUBLIC_URL } from "../serviceWorker";

export const fetchShop = () => async (dispatch: Dispatch<ShopActionTypes>) => {
  dispatch({
    type: RESET_SHOP,
  });
  await axios
    .get(PUBLIC_URL + "api/shop")
    .then((response: any) =>
      dispatch({
        type: FETCH_SHOP,
        payload: response.data,
      })
    )
    .catch((error: any) => console.log(error));
};

export const fetchMenu = () => async (dispatch: Dispatch<ShopActionTypes>) => {
  await axios
    .get(PUBLIC_URL + "api/shop/fetch_menu")
    .then((response: any) =>
      dispatch({
        type: FETCH_MENU,
        payload: response.data,
      })
    )
    .catch((error: any) => console.log(error));
};

export const fetchShopType =
  (request: any) => async (dispatch: Dispatch<ShopActionTypes>) => {
    dispatch({
      type: request.page === 1 ? RESET_SHOP : LOADING_SHOP,
    });
    await axios
      .get(
        `${PUBLIC_URL}api/shop/${request.productTypeId}/${request.page || 1}${
          request.sizeId ? "/" + request.sizeId : ""
        }`
      )
      .then((response: any) =>
        dispatch({
          type: FETCH_SHOP_TYPE,
          payload: {
            products: response.data.products,
            page: request.page || 1,
            last_page: response.data.last_page,
          },
        })
      )
      .catch((error: any) => console.log(error));
  };

export const fetchShopProduct =
  (productId: string) => async (dispatch: Dispatch<ShopActionTypes>) => {
    dispatch({
      type: LOADING_SHOP,
    });
    await axios
      .get(PUBLIC_URL + "api/shop/fetch_product/" + productId)
      .then((response: any) =>
        dispatch({
          type: FETCH_SHOP_PRODUCT,
          payload: response.data,
        })
      )
      .catch((error: any) => console.log(error));
  };

export const fetchShopProductButtonBuy =
  (productId: number) => async (dispatch: Dispatch<ShopActionTypes>) => {
    dispatch({
      type: LOADING_PRODUCT_BUTTONS,
    });
    await axios
      .get(PUBLIC_URL + "api/shop/fetch_product/" + productId)
      .then((response: any) =>
        dispatch({
          type: FETCH_SHOP_PRODUCT,
          payload: response.data,
        })
      )
      .catch((error: any) => console.log(error));
  };

export const setLogin =
  (request: any) => async (dispatch: Dispatch<ShopActionTypes>) => {
    const isLogued = request.isLogued || false;
    dispatch({
      type: SET_LOGIN,
      payload: { isLogued },
    });
    if (!isLogued) {
      localStorage.removeItem("cell_phone");
      localStorage.removeItem("client_id");
    }
  };
